<template lang="html">
  <div class="sponsorship">
    <div class="container">
      <Headline
        :size="3"
        class="sponsorship__headline"
      >
        <span v-editable="resource.columns.title" />
      </Headline>
      <div class="sponsorship__container">
        <SponsorshipApplicationStepTitle
          v-for="(child, index) in resource.children"
          :key="child.id"
          :resource="child"
          :open="openItem === index"
          @toggle="toggleItem(index)"
        />
      </div>
      <SponsorshipApplicationStepBody
        v-for="(child, index) in resource.children"
        :key="child.id"
        :resource="child"
        :open="openItem === index"
      />
      <div class="sponsorship__form">
        <a
          v-if="openItem === 2"
          :href="resource.columns.url"
          target="_blank"
        >
          <Button
            class="sponsorship__btn"
            type="primary"
            @click="continueItem(openItem + 1)"
          >
            Weiter zum Online-Tool
          </Button>
        </a>
        <Button
          v-else
          class="sponsorship__btn"
          type="primary"
          @click="continueItem(openItem + 1)"
        >
          {{ resource.columns.btnText }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Headline from 'beisheim/components/elements/headline'
import Button from 'beisheim/components/elements/button'
import editable from '@i22/frontend-cms-utils/mixins/editable'
import SponsorshipApplicationStepTitle from 'beisheim/components/blocks/sponsorship-application-step-title'
import SponsorshipApplicationStepBody from 'beisheim/components/blocks/sponsorship-application-step-body'

export default {
  components: {
    Headline,
    Button,
    SponsorshipApplicationStepTitle,
    SponsorshipApplicationStepBody
  },
  mixins: [editable],
  data () {
    return {
      openItem: 0
    }
  },
  methods: {
    toggleItem (index) {
      this.openItem = index
    },
    continueItem (index) {
      if (this.openItem < this.resource.children.length - 1) {
        this.openItem = index
      } else {
        this.openItem = 0
      }
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/zindex';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/breakpoints';
  @import 'beisheim/scss/grid';

  .sponsorship {
    padding: scale(20) 0;
    background: #F2F2F2;

    &__container {
      display: flex;
      flex-direction: column;

      @include from(4) {
        flex-direction: row;
      }
    }

    &__headline {
      margin-bottom: scale(10);
    }

    &__btn {
      margin-top: scale(5);
      float: right;
    }

    &__form {
      &:after {
        content: ' ';
        display: block;
        clear: both;
      }
    }

    &__content {
      display: none;
      margin-top: scale(10);
      min-height: 200px;
      box-sizing: border-box;
      &--visible {
        display: block;
      }
    }

    &__mainText {
      font-size: font-size(1);
      max-width: 700px;
    }

    &__subText {
      max-width: 350px;
      margin-top: scale(7);
    }

    &__tab {
      font-size: font-size(1);
      padding: scale(2) 0;
      cursor: pointer;
      border-bottom: 1px solid #999999;
      flex: 1;
      margin: 0;
      opacity: .4;

      @include from(4) {
        margin: 0 scale(4);
      }

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      &--open {
        opacity: 1;
      }
    }
  }

</style>
